<!-- اكتب هنا الهيدر -->
<section dir="{{textDir}}" class="{{textDir}}Class">
  <router-outlet></router-outlet>
</section>
